(ns frontend.sub.entity
  (:require
   [re-frame.core :as rf]))

(rf/reg-sub
 ::entities
 (fn [db _]
   (:entities db)))

(rf/reg-sub
 ::entity
 (fn [db [_ entity-id]]
   (get-in db [:entities entity-id])))

(rf/reg-sub
 ::entities-by-type
 (fn [db _]
   (->> db
        :entities
        (vals)
        (group-by :entity/type))))
